<template>
  <c-input
    as="multiselect"
    v-model="selected"
    placeholder="Select"
    :preselect-first="false"
    :show-labels="false"
    :options="options"
    label="name"
    track-by="id"
  />
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      tagOptions: []
    }
  },

  computed: {
    ...get('lists/energyProviders', ['energyProviders']),

    options () {
      return [...this.energyProviders]
    },

    selected: {
      get () {
        return this.options.find(({ id }) => { if (this.value) { return id === this.value.id } })
      },

      set (option) {
        this.$emit('input', option ? { id: option.id, name: option.name, url: option.url } : null)
      }
    }
  },

  methods: {
    getEnergyProviders: call('lists/energyProviders/getEnergyProviders')
  },

  async created () {
    this.getEnergyProviders()
  }
}
</script>
